export default __webpack_public_path__ + "fonts/ubuntu-greek-400-normal-bf1c79.woff";